<template lang="pug">
  div
    v-autocomplete.pt-0.mt-0.grey--text.ambassador_type_search(
      ref="ambassador_type_search"
      item-text="display_name"
      return-object
      :items="items"
      :menu-props="{ contentClass: 'type-search-menu' }"
      :filter="filter"
      multiple
      :search-input.sync="search"
    )
      template(slot="prepend-inner")
        span.grey--text.text--darken-2(v-if="selectedItems.length") {{ selectedItems.length }}/{{ allTypesWithResults.length }} séléctionnés
      template(slot="item" slot-scope="props")
        v-layout.v-list__tile.px-3.primary.white--text(
          v-if="props.item.category === true"
          :class="isCategorySelected(props.item.title) ? 'primary--text' : ''"
          @click.prevent.stop="toggleCategory(props.item)"
          style="height: 100%; width: 100%;"
        )
          v-list-tile-action
            v-checkbox(:input-value="isCategorySelected(props.item.title)" color="white" dark)
          v-list-tile-content
            v-list-tile-title.white--text {{ props.item.title }}
          v-btn(v-if="foldedCategories.includes(props.item.id)" @click.prevent.stop="unfoldCategory(props.item)" flat icon dark)
            v-icon arrow_right
          v-btn(v-else @click.prevent.stop="foldCategory(props.item)" flat icon dark)
            v-icon arrow_drop_down
        v-layout.v-list__tile.px-3(
          v-else
          :class="isItemSelected(props.item.id) ? 'primary--text' : ''"
          @click.prevent.stop="toggleItem(props.item)"
        )
          v-list-tile-action.ml-4
            v-checkbox(:input-value="isItemSelected(props.item.id)" color="primary")
          v-list-tile-content
            v-list-tile-title(v-html="highlightSearchedText(props.item.display_name)")
      template(slot="no-data")
        v-layout.v-list__tile.px-3()
          v-list-tile-content
            v-list-tile-title Aucun résultat
</template>

<script>
import apiTypeService from '@/services/api/common/typeService';

export default {
  props: {
    entityType: {
      type: String,
      default: 'client',
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCategories: [],
      selectedItems: [],
      foldedCategories: [],
      search: null,
    }
  },
  computed: {
    allTypesWithResults() {
      return this.$store.state[`${this.entityType}s`].searchTypes || [];
    },
    typeCategories() {
      return this.$store.state[`${this.entityType}s`].typeCategories || [];
    },
    entityTypeName() {
      return this.entityType === 'contact' ? 'contact' : 'compte';
    },
    items() {
      const types = [...this.allTypesWithResults];
      const groupedByCategory = types.sort((a, b) => a.category.id - b.category.id);
      const withHeaders = groupedByCategory.reduce((acc, it, idx, tab) => {
        if (idx === 0 && tab.length) {
          acc.push({ category: true, id: it.category?.id, title: it.category.display_name });
        } else if (it.category?.id !== tab[idx - 1].category?.id) {
          acc.push({ divider: true });
          acc.push({ category: true, id: it.category?.id, title: it.category.display_name });
        }
        acc.push(it);
        return acc;
      }, []);
      return withHeaders.filter(it => !it.id || !this.foldedCategories.includes(it.category?.id));
    },
  },
  watch: {
    search() {
      this.selectedCategories = [];
    }
  },
  methods: {
    isCategorySelected(title) {
      return !!this.selectedCategories.find(it => it.title === title);
    },
    isItemSelected(id) {
      return !!this.selectedItems.find(it => it.id === id);
    },
    async createType() {
      if(this.$refs.newTypeForm.validate()) {
        const newType = await apiTypeService.addClientType(this.pendingType);
        if (newType) {
          this.pendingValues.push(newType);
          this.$emit('change', this.pendingValues.map(it => it.id));
        }
        this.newTagDialogIsOpen = false;
        this.pendingType = null;
        this.pendingValues = null;
      }
    },
    selectAllFromCategory(category) {
      const toAdd = this.allTypesWithResults.filter(it => it.category?.id === category?.id && !this.selectedItems.find(item => item.id === it.id))
      this.selectedItems = this.selectedItems.concat(toAdd);
      this.foldCategory(category);
    },
    deselectAllFromCategory(category) {
      this.selectedItems = this.selectedItems.filter(it => !(it.category?.id === category?.id));
      this.unfoldCategory(category);
    },
    isAllCategorySelected(item) {
      const selectedFromCategory = this.selectedItems.filter(it => it.category?.id === item.category?.id)
      const allFromCategory = this.items.filter(it => it.category?.id === item.category?.id)
      return selectedFromCategory.length === allFromCategory.length;
    },
    foldCategory(category) {
      if (!this.foldedCategories.includes(category.id)) {
        this.foldedCategories.push(category.id);
      }
    },
    unfoldCategory(category) {
      if (this.foldedCategories.includes(category.id)) {
        this.foldedCategories.splice(this.foldedCategories.indexOf(category.id), 1);
      }
    },
    toggleCategory(category) {
      if (!!this.selectedCategories.find(it => it.title === category.title)) {
        this.selectedCategories.splice(this.selectedCategories.findIndex(it => it.title === category.title), 1);
        this.deselectAllFromCategory(category);
      } else {
        this.selectedCategories.push(category);
        this.selectAllFromCategory(category);
      }
      this.$emit('change', this.selectedItems.length ? this.selectedItems.map(it => it.id) : null);
    },
    toggleItem(item) {
      if (!!this.selectedItems.find(it => it.id === item.id)) {
        if (this.isAllCategorySelected(item)) {
          this.selectedCategories.splice(this.selectedCategories.findIndex(it => it.id === item.category?.id), 1);
        }
        this.selectedItems.splice(this.selectedItems.findIndex(it => it.id === item.id), 1);
      } else {
        this.selectedItems.push(item);
        if (this.isAllCategorySelected(item)) {
          const category = { category: true, id: item.category?.id, title: item.category.display_name };
          this.foldCategory(category);
          this.selectedCategories.push(category);
        }
      }
      this.$emit('change', this.selectedItems.length ? this.selectedItems.map(it => it.id) : null);
    },
    highlightSearchedText(val) {
      return val.replace(new RegExp(this.search, 'i'), match => `<span class="v-list__tile__mask"">${match}</span>`);
    },
    filter(item, queryText, itemText) {
      const hasChildren = item.category && this.allTypesWithResults.some(it => it.category?.id === item.id && it.display_name?.match(new RegExp(queryText, 'i')));
      const passesFilter = item.display_name && item.display_name.match(new RegExp(queryText, 'i'));
      return hasChildren || passesFilter;
    }
  },
};
</script>

<style lang="scss">
  .type-search-menu {
    .v-list__tile {
      padding: 0;
    }
    .v-list {
      padding-top: 0px;
    }
  }
  .ambassador_type_search {
    .v-input__slot {
      display: flex;
      .v-input__prepend-inner {
        align-self: center;
      }
    }
  }
</style>
